<template>
    <div>
        <img class="sun" src="/dist/images/job/sun.svg" alt="Sun">
        <img class="tilt" :style="{ transform: `rotate(${value}deg) scale(${scale})`}" src="/dist/images/job/spe-tilt.svg" alt="Solar panel tilt">
        <FieldSlider
            :value="value"
            :range="range"
            :slider-options="{ tooltips: tooltipFormat }"
            class="white-theme"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
import wNumb from 'wnumb';
import FieldSlider from '@/form/Slider';

export default {
    components: {
        FieldSlider
    },

    props: {
        value: {
            type: [Number, String],
            default: 0
        }
    },

    data() {
        return {
            tooltipFormat: wNumb({ decimals: 0, suffix: '&deg;' }),
            range: {
                min: 0,
                max: 90
            }
        };
    },

    computed: {
        scale() {
            // Convert value between 0-90 to a value between 0.5-1
            // ((Input - InputLow) / (InputHigh - InputLow)) * (OutputHigh - OutputLow) + OutputLow;
            return ((this.value - this.range.min) / (this.range.max - this.range.min)) * (0.6 - 1) + 1;
        }
    }
};
</script>

<style lang="scss" scoped>
    .sun {
        display: block;
        margin: 0 auto;
    }

    .tilt {
        margin: 75px 0;
    }
</style>
